import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2AnimationIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47.5 47.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.5),
    children: [/*#__PURE__*/jsx("rect", {
      width: "45",
      height: "45",
      x: "1.25",
      y: "1.25",
      rx: "1.304"
    }), /*#__PURE__*/jsx("path", {
      d: "M17.978 27.374a1.252 1.252 0 01-1.152 0 1.042 1.042 0 01-.576-.912V13.216a1.042 1.042 0 01.576-.912 1.252 1.252 0 011.152 0l12.69 6.622a1.01 1.01 0 010 1.83zM7.25 37.25h33M31.25 34.25v6"
    })]
  });
};

export { PM2AnimationIcon };
//# sourceMappingURL=animation.js.map
